import { type HttpInterceptorFn } from '@angular/common/http';

import { SKIP_BASE_URL } from '../tokens';

import { environment } from '@environments/environment';

function joinUrl(base: string, path: string): string {
  if (!base.endsWith('/') && !path.startsWith('/')) {
    return `${base}/${path}`;
  }

  if (base.endsWith('/') && path.startsWith('/')) {
    return `${base}${path.slice(1)}`;
  }

  return `${base}${path}`;
}

function isAbsoluteUrl(url: string): boolean {
  return /^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(url);
}

export const baseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.context.get(SKIP_BASE_URL)) {
    return next(request);
  }

  if (isAbsoluteUrl(request.url)) {
    return next(request);
  }

  const apiRequest = request.clone({
    url: joinUrl(environment.apiUrl, request.url),
  });

  return next(apiRequest);
};
